export const convertToStockItem = product => ( { 
  MaterialId: product.name, 
  Plant: product.plant, 
  BaseUnit: product.baseUnit
 });

 export const getStockColorClassName = ( availability = 16744448 ) => ({
   'available': availability === 65280, 
   'not-available': availability === 16744448, 
   'not-in-stock': availability === 16711680 
 })

 export const getStockColorLabel = ( availability = 16744448 ) => {
  return availability === 65280 ? 'Stock_Green': availability === 16711680 ? 'Stock_Red' : 'Stock_Yellow';
}